/* SUNBORN — Mobile Quick Add (Captain 9/22)
   "+" on the product image (mobile only) -> animated bottom sheet with
   "Pick a size" -> tap a size -> adds that exact color+size variant
   and opens the minicart.

   REUSE, NOT REBUILD: the actual add-to-cart goes through the SAME
   hidden {% form 'product' %} + <cart-action> element that
   snippets/sunborn-quick-size-overlay.liquid already renders on every
   card (Lume's native AJAX add -> cart section refresh -> drawer
   open). This file only picks the variant id, writes it into that
   form's hidden input and calls requestSubmit() -- exactly what the
   existing desktop pill handler in main.js does. No custom cart AJAX.

   COLOR-CORRECT: variant is resolved from (currently selected card
   swatch color + tapped size) using the compact variant JSON the
   overlay snippet emits (.sb-mqa-data), so picking Blue then M adds
   Blue / M, not the first color's M.

   Event delegation on document throughout, so cards appended later
   (Collections Grid "Load More", swiper clones) work with no rebinding.

   v1.1 (9/22): sheet open no longer depends on requestAnimationFrame
   (paused in background tabs/iframes, which left the sheet off-screen
   with the "+" stuck rotated) -- uses a forced reflow instead, and
   close() now always resets the "+" state even if the sheet never
   reached its open state.

   v1.2 (9/22): "Size Guide" link on the "Pick a size" row. Opens the
   SAME lightbox the PDP (snippets/sunborn-inline-sizeguide.liquid) and
   minicart use -- identical .sb-sizeguide-overlay / .sb-sizeguide-modal
   / .sb-sg-* markup, styled once in assets/sunborn-minicart.css
   (z-index 100001, so it layers above this sheet at 1000). Image comes
   from the same custom.size_guide_image metafield ("g" in the card
   JSON); no image = no link. The sheet stays open underneath, so
   closing the size guide drops the shopper straight back into sizes.
   Escape closes the size guide first, then the sheet.

   v1.4 (9/22): IMAGE SWATCH replaces v1.3's circle. A vertical
   rectangle left of the title: top 70% = the selected color's primary
   image, bottom 30% = that color's swatch fill.
   - Image: the card swatch's own `dataimg` attribute (the per-color
     hero image product-grid-option.liquid already renders, 720w),
     re-requested at 200w for a light thumbnail. Falls back to the
     card's currently displayed main image if the swatch has none.
   - Fill: COMPUTED background (color + image) of the card's own
     swatch whose title matches the selected color -- card swatches get
     their fill from CSS classes, not inline data, so reading computed
     style is the only way to match them exactly.
   - No color option at all: the thumb shows the image only, full
     height, and the "Color:" line is hidden. */
(function () {
  'use strict';
  if (window.__sbMqaInit) return;
  window.__sbMqaInit = true;

  var MQ = window.matchMedia('(max-width: 767px)');
  var sheet, panel, titleEl, metaEl, colorNameEl, thumbEl, thumbImgEl, thumbSwEl, promptEl, sgBtn, sizesEl, detailsEl, closeBtn;
  var state = { wrap: null, plus: null, data: null, color: null };

  var ICON_CLOSE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="square" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg>';

  function build() {
    if (sheet) return;
    sheet = document.createElement('div');
    sheet.className = 'sb-mqa-sheet';
    sheet.setAttribute('aria-hidden', 'true');
    sheet.innerHTML =
      '<div class="sb-mqa-backdrop" data-sb-mqa-close></div>' +
      '<div class="sb-mqa-panel" role="dialog" aria-modal="true" aria-labelledby="sb-mqa-title">' +
        '<div class="sb-mqa-grab" data-sb-mqa-close></div>' +
        '<div class="sb-mqa-head">' +
          '<div class="sb-mqa-thumb" aria-hidden="true">' +
            '<span class="sb-mqa-thumb-img"></span>' +
            '<span class="sb-mqa-thumb-sw"></span>' +
          '</div>' +
          '<div class="sb-mqa-head-text">' +
            '<p class="sb-mqa-title" id="sb-mqa-title"></p>' +
            '<p class="sb-mqa-meta">Color: <span class="sb-mqa-color-name"></span></p>' +
          '</div>' +
          '<button type="button" class="sb-mqa-close" data-sb-mqa-close aria-label="Close">' + ICON_CLOSE + '</button>' +
        '</div>' +
        '<div class="sb-mqa-prompt-row">' +
          '<p class="sb-mqa-prompt"></p>' +
          '<button type="button" class="sb-mqa-sg" aria-label="Size Guide"><i class="feather-file-text" aria-hidden="true"></i><span>Size Guide</span></button>' +
        '</div>' +
        '<div class="sb-mqa-sizes" role="group"></div>' +
        '<a class="sb-mqa-details" href="#">View full details</a>' +
      '</div>';
    document.body.appendChild(sheet);
    panel = sheet.querySelector('.sb-mqa-panel');
    titleEl = sheet.querySelector('.sb-mqa-title');
    metaEl = sheet.querySelector('.sb-mqa-meta');
    colorNameEl = sheet.querySelector('.sb-mqa-color-name');
    thumbEl = sheet.querySelector('.sb-mqa-thumb');
    thumbImgEl = sheet.querySelector('.sb-mqa-thumb-img');
    thumbSwEl = sheet.querySelector('.sb-mqa-thumb-sw');
    promptEl = sheet.querySelector('.sb-mqa-prompt');
    sgBtn = sheet.querySelector('.sb-mqa-sg');
    sizesEl = sheet.querySelector('.sb-mqa-sizes');
    detailsEl = sheet.querySelector('.sb-mqa-details');
    closeBtn = sheet.querySelector('.sb-mqa-close');

    sheet.addEventListener('click', function (e) {
      if (e.target.closest('[data-sb-mqa-close]')) {
        e.preventDefault();
        close(true);
        return;
      }
      if (e.target.closest('.sb-mqa-sg')) {
        e.preventDefault();
        if (state.data && state.data.g) openSizeGuide(state.data.g, state.data.t);
        return;
      }
      var chip = e.target.closest('.sb-mqa-size');
      if (chip && !chip.disabled) {
        e.preventDefault();
        addToCart(chip);
      }
    });

    /* swipe the panel down to dismiss */
    var startY = null;
    panel.addEventListener('touchstart', function (e) {
      if (e.touches.length === 1) startY = e.touches[0].clientY;
    }, { passive: true });
    panel.addEventListener('touchend', function (e) {
      if (startY === null) return;
      var dy = e.changedTouches[0].clientY - startY;
      startY = null;
      if (dy > 60) close(true);
    }, { passive: true });
  }

  /* Same markup/classes as snippets/sunborn-inline-sizeguide.liquid
     (PDP) and the minicart's size guide -- styles live in
     assets/sunborn-minicart.css. */
  function openSizeGuide(src, title) {
    var existing = document.querySelector('.sb-sizeguide-overlay');
    if (existing) existing.remove();

    var overlay = document.createElement('div');
    overlay.className = 'sb-sizeguide-overlay';
    overlay.addEventListener('click', function (evt) {
      if (evt.target === overlay) overlay.remove();
    });

    var modal = document.createElement('div');
    modal.className = 'sb-sizeguide-modal';
    modal.innerHTML =
      '<div class="sb-sg-header">' +
        '<span class="sb-sg-title">SIZE GUIDE // ' + escapeHtml(String(title || '').toUpperCase().slice(0, 30)) + '</span>' +
        '<button type="button" class="sb-sg-close" aria-label="Close">&times;</button>' +
      '</div>' +
      '<div class="sb-sg-body"><img src="' + escapeAttr(src) + '" alt="Size Guide"></div>';

    overlay.appendChild(modal);
    document.body.appendChild(overlay);
    var sgClose = modal.querySelector('.sb-sg-close');
    sgClose.addEventListener('click', function () { overlay.remove(); });
    try { sgClose.focus({ preventScroll: true }); } catch (err) {}
  }

  /* Shopify CDN images accept a width param -- request a small one. */
  function thumbUrl(url) {
    if (!url) return '';
    if (/[?&]width=\d+/.test(url)) return url.replace(/([?&]width=)\d+/, '$1200');
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=200';
  }

  /* Build the image swatch: color's primary image on top, its swatch
     fill underneath. */
  function paintThumb(wrap, color) {
    var label = null;
    if (wrap && color) {
      var labels = wrap.querySelectorAll('.item-data label[title]');
      for (var i = 0; i < labels.length; i++) {
        if (labels[i].getAttribute('title') === color) { label = labels[i]; break; }
      }
    }

    /* image */
    var img = '';
    var item = label && label.closest('.item-data');
    if (item && item.getAttribute('dataimg')) img = item.getAttribute('dataimg');
    if (!img && wrap) {
      var main = wrap.querySelector('.product-image .img1 img, .product-image .pro-img img');
      if (main) img = main.getAttribute('src') || main.currentSrc || '';
    }
    img = thumbUrl(img);
    thumbImgEl.style.backgroundImage = img ? 'url("' + img.replace(/"/g, '%22') + '")' : '';

    /* swatch fill */
    thumbSwEl.style.backgroundColor = '';
    thumbSwEl.style.backgroundImage = '';
    var hasFill = false;
    if (label) {
      var src = label.querySelector('.swatch') || label;
      var cs = window.getComputedStyle(src);
      var bgColor = cs.backgroundColor;
      var bgImage = cs.backgroundImage;
      var hasColor = bgColor && bgColor !== 'rgba(0, 0, 0, 0)' && bgColor !== 'transparent';
      var hasImage = bgImage && bgImage !== 'none';
      if (hasColor) thumbSwEl.style.backgroundColor = bgColor;
      if (hasImage) thumbSwEl.style.backgroundImage = bgImage;
      hasFill = hasColor || hasImage;
    }
    thumbEl.classList.toggle('sb-mqa-thumb--no-fill', !hasFill);
    thumbEl.style.display = (img || hasFill) ? '' : 'none';
  }

  function getData(wrap) {
    var el = wrap && wrap.querySelector('.sb-mqa-data');
    if (!el) return null;
    if (!el.__sbParsed) {
      try { el.__sbParsed = JSON.parse(el.textContent); } catch (err) { return null; }
    }
    return el.__sbParsed;
  }

  function findVariant(d, id) {
    for (var i = 0; i < d.v.length; i++) {
      if (String(d.v[i][0]) === String(id)) return d.v[i];
    }
    return null;
  }

  function currentColor(wrap, d) {
    if (d.ci < 0) return null;
    var picked = wrap.getAttribute('data-sb-mqa-variant');
    var v = (picked && findVariant(d, picked)) || findVariant(d, d.i) || d.v[0];
    return v ? v[1][d.ci] : null;
  }

  function variantFor(d, color, size) {
    var fallback = null;
    for (var i = 0; i < d.v.length; i++) {
      var v = d.v[i];
      if (v[1][d.si] !== size) continue;
      if (d.ci < 0 || v[1][d.ci] === color) return v;
      if (!fallback) fallback = v;
    }
    return d.ci < 0 ? fallback : null;
  }

  function isOpen() {
    return !!(sheet && sheet.classList.contains('is-open'));
  }

  function open(plus) {
    var wrap = plus.closest('.single-product-wrap') || plus.closest('.product-image');
    var d = getData(wrap);
    if (!d) return;
    build();

    if (state.plus && state.plus !== plus) {
      state.plus.classList.remove('is-open');
      state.plus.setAttribute('aria-expanded', 'false');
    }
    state.wrap = wrap;
    state.plus = plus;
    state.data = d;
    state.color = currentColor(wrap, d);

    titleEl.textContent = d.t;
    colorNameEl.textContent = state.color || '';
    metaEl.style.display = state.color ? '' : 'none';
    paintThumb(wrap, state.color);
    promptEl.textContent = d.l || 'Pick a size';
    sgBtn.style.display = d.g ? '' : 'none';
    detailsEl.setAttribute('href', d.u);

    var html = '';
    for (var i = 0; i < d.s.length; i++) {
      var size = d.s[i];
      var v = variantFor(d, state.color, size);
      if (!v) continue;
      var avail = !!v[2];
      html += '<button type="button" class="sb-mqa-size" data-variant-id="' + v[0] + '"' +
        (avail ? '' : ' disabled aria-disabled="true"') +
        ' aria-label="Add size ' + escapeAttr(size) + ' to cart">' + escapeHtml(size) + '</button>';
    }
    sizesEl.innerHTML = html;

    plus.classList.remove('is-pop');
    void plus.offsetWidth;
    plus.classList.add('is-pop', 'is-open');
    plus.setAttribute('aria-expanded', 'true');

    sheet.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('sb-mqa-lock');
    /* force a reflow so the closed state is committed, then add the
       open class in the same task -- the CSS transition still runs */
    void sheet.offsetWidth;
    sheet.classList.add('is-open');
    var first = sizesEl.querySelector('.sb-mqa-size:not(:disabled)');
    try { (first || closeBtn).focus({ preventScroll: true }); } catch (err) {}
  }

  function close(restoreFocus) {
    var sg = document.querySelector('.sb-sizeguide-overlay');
    if (sg) sg.remove();
    if (sheet) {
      sheet.classList.remove('is-open');
      sheet.setAttribute('aria-hidden', 'true');
    }
    document.documentElement.classList.remove('sb-mqa-lock');
    if (state.plus) {
      state.plus.classList.remove('is-open');
      state.plus.setAttribute('aria-expanded', 'false');
      if (restoreFocus) {
        try { state.plus.focus({ preventScroll: true }); } catch (err) {}
      }
    }
  }

  function addToCart(chip) {
    var wrap = state.wrap;
    var plus = state.plus;
    var variantId = chip.getAttribute('data-variant-id');
    var form = wrap && wrap.querySelector('.sb-quick-size-native-form');
    if (!form || !variantId) return;
    var input = form.querySelector('input[name="id"]');
    if (!input) return;

    chip.classList.add('is-selected');
    input.value = variantId;
    var cartAction = form.closest('cart-action');
    if (cartAction) {
      cartAction.classList.add('sb-quick-size--loading');
      setTimeout(function () { cartAction.classList.remove('sb-quick-size--loading'); }, 2500);
    }

    /* Close the sheet first so the minicart drawer that <cart-action>
       opens on success isn't layered underneath it. */
    close(false);

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }

    if (plus) {
      plus.classList.add('is-added');
      setTimeout(function () { plus.classList.remove('is-added'); }, 1600);
    }
    try {
      document.dispatchEvent(new CustomEvent('sunborn:mobile-quick-add', {
        detail: { variantId: variantId, productUrl: state.data && state.data.u }
      }));
    } catch (err) {}
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  var escapeAttr = escapeHtml;

  document.addEventListener('click', function (e) {
    /* remember the card's selected swatch (same id convention main.js
       uses: variant id is the last "-" segment of .item-data's id) */
    var sw = e.target.closest('.item-data');
    if (sw) {
      var w = sw.closest('.single-product-wrap');
      var id = (sw.id || '').split('-').pop();
      if (w && /^\d+$/.test(id)) w.setAttribute('data-sb-mqa-variant', id);
    }

    var plus = e.target.closest('button.sb-mqa-plus');
    if (plus) {
      e.preventDefault();
      e.stopPropagation();
      if (!MQ.matches) return;
      if (isOpen() && state.plus === plus) { close(true); } else { open(plus); }
      return;
    }

    /* Search page's quick-cart "reveal" button would toggle the size
       strip, which is hidden in "+" mode on mobile -- route it to the
       sheet instead. */
    var qc = e.target.closest('.sb-quick-cart-btn[data-mode="reveal"]');
    if (qc && MQ.matches) {
      var wrap = qc.closest('.single-product-wrap');
      var p = wrap && wrap.querySelector('button.sb-mqa-plus');
      if (p) {
        e.preventDefault();
        open(p);
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var sg = document.querySelector('.sb-sizeguide-overlay');
    if (sg && isOpen()) {
      sg.remove();
      if (sgBtn) { try { sgBtn.focus({ preventScroll: true }); } catch (err) {} }
      return;
    }
    if (isOpen()) close(true);
  });

  var onChange = function (ev) { if (!ev.matches) close(false); };
  if (MQ.addEventListener) { MQ.addEventListener('change', onChange); }
  else if (MQ.addListener) { MQ.addListener(onChange); }
})();
